import {IconButton, Stack, Tooltip} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import ReorderIcon from "@mui/icons-material/Reorder";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import {TreeInput} from "../general/inputs/TreeInput";
import PropTypes from "prop-types";
import {useRecoilValue} from "recoil";
import {subState} from "../../services/requestService";
import {useSnackbar} from "notistack";
import {TEXT_NODE_VIEW} from "./useTree";
import {COLLECTION_ROLE} from "../../constants";


export default function RegionLabel(props) {
    const {label, editable, toggleEdit, onChangeViewMode, onSave, role} = props;
    const {t} = useTranslation("common");
    const sub = useRecoilValue(subState);
    const {enqueueSnackbar} = useSnackbar();

    const handleEdit = () => {
        if (sub !== "readonly" && !editable) {
            toggleEdit();
        } else {
            enqueueSnackbar(t("main.components.dataViewer.notification.loginfirst"), {variant: "warning"});
        }
    }

    return (
        <>
            <Stack direction="row-reverse" p="1px">
                <Stack direction="row" ml={1}>
                    {[COLLECTION_ROLE.OWNER, COLLECTION_ROLE.MAINTAINER, COLLECTION_ROLE.EDITOR].includes(role) &&
                        <Tooltip
                            title={editable ? t("main.components.dataViewer.button.save") : t("main.components.dataViewer.button.edit")}
                            arrow>
                            {editable ?
                                <IconButton
                                    aria-label="save rows" size="small"
                                    type="submit"
                                    onClick={onSave}
                                >
                                    <SaveIcon fontSize="small"/>
                                </IconButton> :
                                <IconButton
                                    aria-label="edit rows" size="small"
                                    onClick={handleEdit}>
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                            }
                        </Tooltip>
                    }
                    <Tooltip
                        title={t("main.components.dataViewer.button.treeMode")}
                        arrow>
                        <IconButton aria-label="show text" size="small"
                                    onClick={() => onChangeViewMode(TEXT_NODE_VIEW.TREE)}>
                            <ReorderIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        title={t("main.components.dataViewer.button.textMode")}
                        arrow>
                        <IconButton aria-label="show text" size="small"
                                    onClick={() => onChangeViewMode(TEXT_NODE_VIEW.TEXT)}>
                            <ListAltIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        title={t("main.components.dataViewer.button.labelMode")}
                        arrow>
                        <IconButton aria-label="show text" size="small"
                                    onClick={() => onChangeViewMode(TEXT_NODE_VIEW.LABEL)}>
                            <LocalOfferIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                </Stack>
                <TreeInput
                    disabled
                    disableUnderline
                    fullWidth
                    size="small"
                    value={label}
                />
            </Stack>
        </>
    );
}

RegionLabel.propTypes = {
    label: PropTypes.string,
    editable: PropTypes.bool.isRequired,
    toggleEdit: PropTypes.func.isRequired,
    onChangeViewMode: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
}
